import React from 'react'
import {connect} from 'react-redux'
import {filterActionList} from "../actions"
import styled from 'styled-components'
import {StyledInput} from '../styled-components/components'
const StyledFilterBar = styled(StyledInput)`
   border-bottom:1px solid #c8c8c8;
    color:white;
    height:42px;
`
const FilterBar = ({dispatch}) => {
    return(<StyledFilterBar placeholder="FILTER..." type="text" onChange={(e)=>dispatch(filterActionList(e.target.value))}  />)
}

export default connect()(FilterBar)